<p class="text-center">
  Loggin out ...
</p>
